import { z } from 'zod/v4';

export const assetPasswordResetResultSchema = z.object({
  errorCode: z.string().nullable(),
  totalPasswordResets: z.number(),
  totalPasswordResetFailures: z.number(),
});

export type AssetPasswordResetResult = z.infer<
  typeof assetPasswordResetResultSchema
>;
